<template lang="pug">
    r-table(
        no-data-text='Sin descuentos por planilla.'
        no-filter
        no-remove
        no-search
        ref='table'
        v-bind='tableProps'
        @detail='submitDetail'
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { RTable } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import EmployeeIcQuoteModel from '@/models/HumanResource/HrEmployeeIcQuote'
    import EmployeeIcQuoteHeaders from '@/views/HumanResource/HrEmployeeIcQuote/HrEmployeeIcQuoteHeaders'
    //
    export default {
        name: 'employee-ic-quote-create',
        components: {
            RTable,
        },
        computed: {

            /**
             * @description
             * { item_description }
             */
            ...mapState('SnackbarModalModule', [
                'responseConfirm',
            ]),

            /**
             * @description
             * { function_description }
             *
             * @return     {Object}  { description_of_the_return_value }
             */
            tableProps() {
                return {
                    headers: EmployeeIcQuoteHeaders,
                    service: EmployeeIcQuoteModel,
                    paramFilter: {
                        hr_employee_id: this.$route.params.id,
                    },
                }
            },
        },
        methods: {

            /**
             * @description
             * { item_description }
             */
            ...mapActions('MenuesModule', [
                'setItemsTopBar',
                'setTitleTopBar',
            ]),

            /**
             * @description
             * { item_description }
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             * @description
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            error() {
                return this.setErrorSnackbar('No esta incluida en una liquidacion.')
            },

            /**
             * @description
             * { function_description }
             *
             * @param      {<type>}  id      The identifier
             * @return     {<type>}  { description_of_the_return_value }
             */
            redirect(id) {
                return this.$router.push({ 
                    name: 'salary-settlement-update', 
                    params: {
                        id,
                    },
                })
            },

            /**
             * @description
             * { function_description }
             *
             * @return     {<type>}  { description_of_the_return_value }
             */
            refresh() {
                return this.$refs.table.refresh()
            },

            /**
             * @description
             * { function_description }
             *
             * @param      {<type>}  event   The event
             * @return     {<type>}  { description_of_the_return_value }
             */
            submitDetail(event) {
                return event.item.hr_salary_settlement_id ? this.redirect(event.item.hr_salary_settlement_id) : this.error()
            },
        },
    }
</script>
